import { render } from "./GbpCircleFilledIcon.vue?vue&type=template&id=52fb8b5f"
import script from "./GbpCircleFilledIcon.vue?vue&type=script&lang=js"
export * from "./GbpCircleFilledIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__